import { makeService } from './api';

export default makeService('backend_groups');
